module.exports = __webpack_public_path__ + "static/media/carousel_rootbeer_2.d2114964.jpg";